<template>
  <v-card class="mx-auto">
    <v-list-item>
      <v-list-item-avatar @click="$emit('profile')">
        <v-img class="elevation-6" :src="profile.avatar"></v-img>
      </v-list-item-avatar>
      <v-list-item-content @click="$emit('profile')">
        <v-list-item-title class="title font-weight-light">
          {{profile.name}}
        </v-list-item-title>
        <v-list-item-subtitle class="subtitle">
          <v-row class="pl-2">
            <v-rating v-model="profile.rating" small dense half-increments color="primary" background-color="primary" readonly></v-rating>
            <span class=" caption ml-2">
              ({{ profile.rating }})
            </span>
          </v-row>
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon @click="show = !show">
          <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </v-list-item-action>
      <!-- <v-list-item-action v-if="chat || pay">
        <v-icon v-if="chat && !pay" color="white" @click="$emit('message')">chat</v-icon>
        <div v-if="profile.status === 'Paid'">
          <span class="caption grey--text text--darken-3">Paid </span>
          <v-icon small color="green" class="font-weight-bold">check</v-icon>
        </div>
        <v-btn v-if="(pay && !chat) && (profile.status === 'Completed') && profile.expenses||(payShift&&!chat)" @click="$emit('pay')">
          <v-icon color="green">attach_money</v-icon>
          <div class="mr-2">
            PAY NOW
          </div>
        </v-btn>
      </v-list-item-action> -->
    </v-list-item>
    <v-expand-transition>
      <div v-if="show">
        <v-divider v-if="profile.bid"></v-divider>

        <v-list-item v-if="profile.bid">
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              Bid Introduction
            </v-list-item-title>
            <span class="py-1 body-2">{{profile.bid.jobDesc}}</span>
            <v-row no-gutters class="py-2">
              <v-col cols="7" class="pa-0">
                <v-list-item-subtitle class="subtitle">
                  {{$language.jobDetails['Start Date']}}:
                </v-list-item-subtitle>
                <span class="body-1 font-weight-bold">
                  {{profile.bid.startDate}}
                </span>
              </v-col>
              <v-col cols="5" class="pa-0">
                <v-list-item-subtitle class="subtitle">
                  {{$language.jobDetails['Start Time']}}:
                </v-list-item-subtitle>
                <span class="body-1 font-weight-bold">
                  {{profile.bid.startTime.h}}:{{profile.bid.startTime.mm}} {{profile.bid.startTime.A}}
                </span>
              </v-col>
            </v-row>
            <span v-if="profile.bid.repeat">Repeats: {{profile.bid.scheduleText}}</span>
          </v-list-item-content>
          <v-list-item-action>
          </v-list-item-action>
        </v-list-item>

        <v-divider></v-divider>
        <v-list-item class="pb-2">
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              {{ $language.settings['Reviews'] }}
            </v-list-item-title>
            <v-row no-gutters justify="center">
              <div class="text-xs-center mt-1" v-if="Object.entries(ratings).length > 1">
                <v-icon class="mx-3" style="vertical-align: middle;" @click="prev">fas fa-arrow-circle-left</v-icon>
                <span class="">{{ currentReview + 1 }} / {{ Object.entries(ratings).length }}</span>
                <v-icon class="mx-3" style="vertical-align: middle;" @click="next">fas fa-arrow-circle-right</v-icon>
              </div>
              <v-window v-model="currentReview" :touch="{ left: prev, right: next }" v-if="ratings">
                <v-window-item v-for="(review, index) in ratings" :key="index">

                  <v-col cols="12" class="body-1  pb-0  text-xs-center" align="center">
                    <v-rating v-model="review.rating" class="mb-1" background-color="primary" half-increments readonly></v-rating>
                  </v-col>
                  <v-col cols="12" class="body-1  py-0 text-xs-left" align="center">
                    {{ review.comment }}
                  </v-col>
                  <v-col cols="12" class="caption text-xs-right " align="center">
                    - From {{ review.ratedByName }} ({{ review.ratingDate|formatShortDate }})
                  </v-col>
                </v-window-item>
              </v-window>

              <v-col cols="12" align="center">

                <div v-if="!ratings" class="text-xs-center py-3 grey--text text--darken-3">
                  {{ $language.settings['No reviews yet'] }}.
                </div>
              </v-col>
            </v-row>

          </v-list-item-content>
        </v-list-item>
      </div>
    </v-expand-transition>

    <v-divider ></v-divider>
    <v-card-actions class="px-0" v-if="profile.status!=='Declined'">
      <v-list-item v-if="profile.status==='Applied'">
        <v-list-item-title class="font-weight-bold green--text">
          <span v-if="((job||{}).public||{}).bid">
            Bid: ${{((job||{}).public||{}).rateType==='Fixed'?profile.bid.compensation:profile.bid.rate}}<span>{{((job||{}).public||{}).rateType==='Fixed'?'':'/hr'}}</span>
          </span>
        </v-list-item-title>
        <v-list-item-action>
          <v-btn icon color="error" @click="declineOverlay = true">
            <v-icon>thumb_down</v-icon>
          </v-btn>
        </v-list-item-action>
        <v-list-item-action class="px-6">
          <v-btn icon color="success" @click="hireOverlay = true">
            <v-icon>thumb_up</v-icon>
          </v-btn>
        </v-list-item-action>
        <v-list-item-action class="ml-0" @click="openChat">
          <v-btn icon>
            <v-icon>chat</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-list-item v-if="profile.status==='Hired'||profile.status==='Started'||profile.status==='Completed'||profile.status==='Paid'||profile.status==='Pending Payment'">
        <v-list-item-content>
          <v-list-item-title class="title">
            <span v-if="profile.paymentRequested" class=" title error--text">Pay Now</span>
            <span v-else class="title">{{$language.jobDetails.status[profile.status]}}</span>
          </v-list-item-title>

        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon @click="favorite">
            <v-icon v-if="isFav" color="error lighten-2">favorite</v-icon>
            <v-icon v-else >favorite_border</v-icon>
          </v-btn>
        </v-list-item-action>
        <v-list-item-action class="px-2 " v-if="pay&&!canRemove">
          <v-btn icon @click="$emit('pay')">
            <v-badge right color="error" dot v-if="profile.paymentRequested||profile.status==='Pending Payment'||payShift">
              <v-icon>payment</v-icon>
            </v-badge>
            <v-icon v-else>payment</v-icon>
          </v-btn>
        </v-list-item-action>
        <v-list-item-action class="px-2 " v-if="canRemove">
          <v-btn icon @click="removeOverlay=true">

            <v-icon >mdi-delete</v-icon>
          </v-btn>

        </v-list-item-action>
        <v-list-item-action class="ml-0" @click="openChat">
          <v-btn icon>
            <v-icon>chat</v-icon>
          </v-btn>
        </v-list-item-action>

      </v-list-item>
    </v-card-actions>
    <v-card-actions v-else>
      <v-list-item>
        <v-list-item-content>

        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon @click="favorite">
            <v-icon v-if="isFav" color="error darken-1">favorite</v-icon>
            <v-icon v-else color="error darken-1">favorite_border</v-icon>
          </v-btn>
        </v-list-item-action>
        <v-list-item-action >
          <v-btn icon color="success" @click="hireOverlay = true">
            <v-icon>thumb_up</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-card-actions>
    <v-fade-transition>
      <v-overlay absolute color="black" v-show="hireOverlay">
        <v-btn color="grey lighten-1 mx-1" @click="hireOverlay = false">Cancel</v-btn>
        <v-btn color="green darken-1 mx-1" @click="confirmHire">Hire Now</v-btn>
      </v-overlay>
    </v-fade-transition>
    <v-fade-transition>
      <v-overlay absolute color="black" v-show="declineOverlay">
        <v-btn color="grey lighten-1 mx-1" @click="declineOverlay = false">Cancel</v-btn>
        <v-btn color="error darken-1 mx-1" @click="declineHire">Decline Hire</v-btn>
      </v-overlay>
    </v-fade-transition>
    <v-fade-transition>
      <v-overlay absolute color="black" v-show="removeOverlay">
        <v-btn color="grey lighten-1 mx-1" @click="removeOverlay = false">Cancel</v-btn>
        <v-btn color="error darken-1 mx-1" @click="removeWorker">Decline Hire</v-btn>
      </v-overlay>
    </v-fade-transition>
  </v-card>
  <!-- <v-list-item style="cursor: pointer;">
    <v-list-item-avatar @click="$emit('profile')">
      <img :src="profile.avatar">
    </v-list-item-avatar>
    <v-list-item-content @click="$emit('profile')">
      <v-list-item-title class="pl-1 grey--text text--darken-3">{{profile.name}}</v-list-item-title>
      <v-list-item-subtitle class="caption " v-if="profile.rating">
        <v-rating v-model="profile.rating" small dense></v-rating>
      </v-list-item-subtitle>
      <v-list-item-subtitle class="caption pl-1" v-else>Not enough ratings yet.</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="chat || pay">
      <v-icon v-if="chat && !pay" :color="profile.active ? 'teal' : 'grey'" @click="$emit('message')">chat_bubble</v-icon>
      <div v-if="profile.status === 'Paid'">
        <span class="caption grey--text text--darken-3">Paid </span>
        <v-icon small color="green" class="font-weight-bold">check</v-icon>
      </div>
      <v-btn v-if="(pay && !chat) && (profile.status === 'Completed') && profile.expenses||(payShift&&!chat)" @click="$emit('pay')">
        <v-icon color="green">attach_money</v-icon>
        <div class="mr-2">
          PAY NOW
        </div>
      </v-btn>
    </v-list-item-action>
  </v-list-item> -->
</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
const fb = require('@/services/firebaseConfig.js')

export default {
  props: ['profile', 'chat', 'pay', 'jobKey', 'color', 'job', 'userFav'],
  data () {
    return {
      sub: '',
      show: false,
      hireOverlay: false,
      declineOverlay: false,
      removeOverlay: false,
      ratings: {},
      currentReview: 0
    }
  },
  mounted () {
    fb.database.ref(`/user/${this.profile.profileId}/profile/public/ratings`).once('value').then(function (snapshot) {
      this.ratings = snapshot.val() === null ? {} : snapshot.val()
    }.bind(this))
  },
  computed: {
    ...mapState(['userProfile', 'currentUser']),
    payShift () {
      var shouldPay = Object.values((this.profile || {}).jobLog || {}).filter(k => k.status === 'pending')
      return shouldPay.length > 0
    },
    isFav () {
      if (this.userFav !== undefined) {
        if (this.userFav[this.profile.profileId] !== undefined) {
          return this.userFav[this.profile.profileId]
        }
      }
      return false
    },
    hiredMax () {
      return !(parseInt(this.job.public.workers) - parseInt(this.job.public.hiredWorkers) > 0)
    },
    canRemove () {
      return this.profile.status === 'Applied' || this.profile.status === 'Hired'
    }
  },
  methods: {
    next () {
      if (this.currentReview > this.profile.length) {
        this.currentReview = 0
      } else {
        this.currentReview += 1
      }
    },

    prev () {
      if (this.currentReview !== 0) {
        this.currentReview -= 1
      } else {
        this.currentReview = this.profile.length - 1
      }
    },
    confirmHire () {
      this.hireOverlay = false
      this.$emit('confirm-hire', {
        profileId: this.profile.profileId
      })
    },

    async declineHire () {
      this.buttonLoading = true
      var updates = {}
      var updatedDate = new Date()
      var newKey = await fb.database.ref().child(`user/${this.profile.profileId}/profile/notifications`).push().key

      var notification = {
        'notificationType': 'Hire Declined',
        'notificationText': `You have been denied, better luck tomorrow.`,
        'notificationDate': updatedDate,
        'jobId': '',
        'defaultTab': '',
        route: 'obr'
      }
      updates[`jobs/${this.job._key}/applicants/${this.profile.profileId}/status`] = 'Declined'
      updates[`jobs/${this.job._key}/applicants/${this.profile.profileId}/status`] = 'Declined'
      updates[`jobs/${this.job._key}/public/numberOfApplicants`] = parseFloat(this.job.public.numberOfApplicants - 1)
      updates[`user/${this.profile.profileId}/jobs/${this.job._key}/status`] = 'Declined'
      updates[`user/${this.profile.profileId}/jobs/${this.job._key}/updatedDate`] = updatedDate
      updates[`user/${this.profile.profileId}/profile/notifications/${newKey}`] = notification
      await fb.database.ref().update(updates)
      this.buttonLoading = false
      this.declineOverlay = false
    },
    async removeWorker () {
      this.buttonLoading = true
      var updates = {}
      var updatedDate = new Date()
      var newKey = await fb.database.ref().child(`user/${this.profile.profileId}/profile/notifications`).push().key

      var notification = {
        'notificationType': 'Hire Declined',
        'notificationText': `You have been denied, better luck tomorrow.`,
        'notificationDate': updatedDate,
        'jobId': '',
        'defaultTab': '',
        route: 'obr'
      }
      updates[`jobs/${this.job._key}/applicants/${this.profile.profileId}/status`] = 'Declined'
      updates[`jobs/${this.job._key}/applicants/${this.profile.profileId}/status`] = 'Declined'
      updates[`user/${this.profile.profileId}/jobs/${this.job._key}/status`] = 'Declined'
      updates[`user/${this.profile.profileId}/jobs/${this.job._key}/updatedDate`] = updatedDate
      updates[`user/${this.profile.profileId}/profile/notifications/${newKey}`] = notification
      updates[`/user/${this.job.public.createdBy}/jobs/${this.job._key}/hiredWorkers`] = parseInt(this.job.public.hiredWorkers) - 1
      updates[`/jobs/${this.job._key}/public/hiredWorkers`] = parseInt(this.job.public.hiredWorkers) - 1
      if (this.job.public && parseInt(this.job.public.hiredWorkers) - 1 === 0) {
        await fb.geoFireApp.set(this.job.public._key, this.job.public.location)
      }
      await fb.database.ref().update(updates)
      this.buttonLoading = false
      this.declineOverlay = false
    },

    favorite () {
      if (this.isFav) {
        this.removeFavorite()
      } else {
        this.addFavorite()
      }
    },

    async addFavorite () {
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/favorites/${this.profile.profileId}`] = {
        name: this.profile.name
      }
      await fb.database.ref().update(updates)
    },
    async removeFavorite () {
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/favorites/${this.profile.profileId}`] = null
      await fb.database.ref().update(updates)
    },
    openChat () {
      this.$store.commit('setChatOpen', { open: true, date: new Date() })
      this.$nextTick(() => {
        this.$store.dispatch('changeChatSelection', { jobId: this.job.public._key, isHefe: true, currentUser: this.currentUser.uid })
      })
    }
  },

  filters: {
    acceptedApplicants (val) {
      return Object.keys(val).reduce(function (acc, key) {
        if (val[key] === 'Applied') {
          return acc + 1
        }
        return acc
      }, 0)
    },
    formatImgURL (val) {
      return '@/assets/Agriculture.svg'
    },

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    },
    trimLength (val) {
      return `${val.substring(0, 8)}...`
    },
    formatTime (val) {
      return moment(val).format('hh:mm a')
    }
  }
}
</script>
